import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { applyFlowTenant } from '../tenant';
import { af, applyFlowThemeCss } from '../theme';

const styles = {
  /**
   * Declares the flow's tokens itself.
   *
   * `ApplyStage` normally stamps them, but this renders *instead of* the page — the shell
   * has not mounted and neither have its custom properties. Without this the scooter's
   * `color: var(--af-ink)` resolves to nothing and it inherits whatever the app root has.
   *
   * Sized like the stage it hands over to — the smallest viewport, as a minimum — so the
   * ground does not change under the candidate at the moment the flow takes over. See the
   * height note in ApplyStage.styles.ts.
   */
  root: css`
    ${applyFlowThemeCss(applyFlowTenant.brandColor)};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100svh;

    @supports not (min-height: 100svh) {
      min-height: 100vh;
    }
    background: ${af.stage};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
